var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-42.000000, -1638.000000)","fill":"#0C8044"},React.createElement("g",{"transform":"translate(18.000000, 1204.000000)"},React.createElement("g",null,React.createElement("polygon",{"points":"31 444.5 26.8855032 446.663119 27.6713022 442.081559 24.3426044 438.836881 28.9427516 438.168441 31 434 33.0572484 438.168441 37.6573956 438.836881 34.3286978 442.081559 35.1144968 446.663119"}))))));
}

Star.defaultProps = {"width":"14px","height":"13px","viewBox":"0 0 14 13","version":"1.1"};

module.exports = Star;

Star.default = Star;
